// extracted by mini-css-extract-plugin
module.exports = {"component":"styles_component__2iLhW","visually-hidden":"styles_visually-hidden__3N3Hk","icon":"styles_icon__2HEHN","input":"styles_input__2FoOc styles_visually-hidden__3N3Hk"};